import React from 'react';
import Head from 'next/head';
import { getTdk } from 'utils/tdk';
interface IProps {
  pageKey: string;
}
const Index = (props: IProps) => {
  const { title, keyword, desc } = getTdk(props.pageKey);
  return (
    <Head>
      <title>{title}</title>
      <meta name="keywords" content={keyword} />
      <meta name="description" content={desc} />
    </Head>
  );
};

export default Index;
